
<div>
  <mat-card>
    
      <mat-card-header>
        <mat-card-title i18n="section header">Language</mat-card-title>
      </mat-card-header>
      
      <mat-card-content>
        <language-selector/>
      </mat-card-content>
  </mat-card>
</div>